/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Execute_Output7Inputs */

const en_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tested app build`)
};

const ar_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخة تطبيق مختبرة`)
};

const bn_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টেস্টেড অ্যাপ বিল্ড`)
};

const de_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getesteter App-Build`)
};

const es_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación de aplicación probada`)
};

const fr_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version d'application testée`)
};

const pt_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação de aplicativo testada`)
};

const zh_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测试的应用程序构建`)
};

const tr_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test edilmiş uygulama derlemesi`)
};

const ru_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Протестированная сборка приложения`)
};

const pl_svc_mobile_app_development_execute_output7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testowana wersja aplikacji`)
};

/**
* | output |
* | --- |
* | "Tested app build" |
*
* @param {Svc_Mobile_App_Development_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_execute_output7 = /** @type {((inputs?: Svc_Mobile_App_Development_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "de") return de_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "es") return es_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_execute_output7(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_execute_output7(inputs)
	return en_svc_mobile_app_development_execute_output7(inputs)
});
export { svc_mobile_app_development_execute_output7 as "svc_mobile-app-development_EXECUTE_output" }